module.exports = __webpack_public_path__ + "img/guanbi.187ef49a.svg";